import VaspTransferForm from './VaspTransferForm'

export default VaspTransferForm
